export const GRID_NUMBER_CHECKBOX = 'gridNumberCheckbox';
export const LEDGER = 'ledger';
export const STRING = 'string';
export const GRID_DATE = 'gridDate';
export const NUMBER = 'number';
export const PERCENTAGE = 'percentage';
